import { AnchorHTMLAttributes, ReactElement, ReactNode } from "react";
import {
    AUTHENTICATION_STORED_ITEM,
    authenticationFlag,
    authenticationProperty,
} from "../../shared/utils/authentication-item.utils";
import { useStoredItem } from "../../state/InternalContext";
import { useAuth } from "../internal/AuthProvider";
import { AuthActionAnchor } from "./auth-action-anchor";

interface LogoutButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    children?: ReactNode;
}

/**
 * Signs out. Renders only when `_authentication` `showLogout` is true.
 * The anchor does not navigate. `logout` still performs the existing full-page redirect.
 */
export function LogoutButton({ children, ...anchorProps }: LogoutButtonProps): ReactElement | null {
    const item = useStoredItem(AUTHENTICATION_STORED_ITEM);
    const { logout } = useAuth();
    const name = authenticationProperty(item, "name");
    const email = authenticationProperty(item, "email");

    if (!authenticationFlag(item, "showLogout")) {
        return null;
    }

    return (
        <AuthActionAnchor
            {...anchorProps}
            defaultLabel={`Logout (${name || email || "User"})`}
            title="Logout"
            onAction={() => {
                void logout();
            }}
        >
            {children}
        </AuthActionAnchor>
    );
}
